import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import RegistroVisitantesEntradas from "../../../views/administracion/registroVisitantes/RegistroVisitantesEntradas/RegistroVisitantesEntradas";
import PanelAdministracion from "../../../views/administracion/registroVisitantes/PanelAdministracion/PanelAdministracion";
import RegistroVisitantesSalidas from "../../../views/administracion/registroVisitantes/RegistroVisitantesSalidas/RegistroVisitantesSalidas";
import RegistroVisitantesGraficas from "../../../views/administracion/registroVisitantes/RegistroVisitantesGraficas/RegistroVisitantesGraficas";
import TicketsDeGasolinaMain from "../../../views/administracion/TiketsDeGasolina/TicketsDeGasolinaMain/TiketsDeGasolinaMain";
import PagoAliados from "../../../views/administracion/PagoAliados/PagoAliados";
import TicketsDeGasolinaDetails
    from "../../../views/administracion/TiketsDeGasolina/TickesDeGasolinaDetails/TicketsDeGasolinaDetails";
import ControlDeExtracciones from "../../../views/administracion/ControlDeExtracciones/ControlDeExtracciones";
import ControlInsumos from "../../../views/administracion/insumos/ControlInsumos";
import KilometrajePorUnidad from "../../../views/administracion/KilometrajePorUnidad/KilometrajePorUnidad";
import TicketManagement from "../../../views/administracion/GestionTickets/GestionTickets";
import GestorDeArchivos from "../../../views/administracion/GestorDeArchivos/GestorDeArchivos";

const Administacion = () => {
    return (
        <Routes>
            {/* registro visitantes */}
            <Route exact path="/administracion/registro-visitantes/entradas" element={<Suspense fallback={<>skeleton</>}>
                <RegistroVisitantesEntradas></RegistroVisitantesEntradas>
            </Suspense>} />
            <Route exact path="/administracion" element={<Suspense fallback={<>skeleton</>}>
                <PanelAdministracion></PanelAdministracion>
            </Suspense>} />
            <Route exact path="/administracion/registro-visitantes/salidas" element={<Suspense fallback={<>skeleton</>}>
                <RegistroVisitantesSalidas></RegistroVisitantesSalidas>
            </Suspense>} />
            <Route exact path="/administracion/registro-visitantes/graficas" element={<Suspense fallback={<>skeleton</>}>
                <RegistroVisitantesGraficas></RegistroVisitantesGraficas>
            </Suspense>} />
            {/* tikets de gasolina */}
            <Route exact path="/administracion/tickets-gasolina" element={<Suspense fallback={<>skeleton</>}>
                <TicketsDeGasolinaMain></TicketsDeGasolinaMain>
            </Suspense>} />
            <Route exact path="/administracion/gestion-tickets" element={<Suspense fallback={<>skeleton</>}>
                <TicketManagement/>
            </Suspense>} />
            <Route exact path="/administracion/pago-aliados" element={<Suspense fallback={<>skeleton</>}>
                <PagoAliados></PagoAliados>
            </Suspense>} />
            <Route exact path="/administracion/ordenes-compra/:id" element={<Suspense fallback={<>skeleton</>}>
                <TicketsDeGasolinaDetails></TicketsDeGasolinaDetails>
            </Suspense>} />
            <Route exact path="/administracion/control-extraccion" element={<Suspense fallback={<>skeleton</>}>
                <ControlDeExtracciones></ControlDeExtracciones>
            </Suspense>} />
            <Route exact path="/administracion/control-insumos" element={<Suspense fallback={<>skeleton</>}>
                <ControlInsumos></ControlInsumos>
            </Suspense>} />
            <Route exact path="/operaciones/kilometraje-por-unidad" element={<Suspense fallback={<>skeleton</>}>
                <KilometrajePorUnidad></KilometrajePorUnidad>
            </Suspense>} />
            <Route exact path="/administracion/gestor-archivos" element={<Suspense fallback={<>skeleton</>}>
                <GestorDeArchivos></GestorDeArchivos>
            </Suspense>} />
           
        </Routes>
    )
}
export default Administacion